import gql from 'graphql-tag';

export const GET_TEAMS_MEMBERS = gql`
  query($team_ids: [Int]) {
    getMembersByTeamIdsArray(team_ids: $team_ids) {
      id
      name
      email
      teams {
        id
        name
      }
    }
  }
`;

export const GET_ALGOLIA_API_KEY = gql`
  query {
    getAlgoliaApiKey {
      api_key
    }
  }
`;

export const GET_EXPERT_BY_SLUG = gql`
  query($slug: String) {
    getFilteredUsers(filter: { slug: [$slug] }) {
      id
      name
      avatar
      job_title
      description
      count_videos
      slug
    }
  }
`;

export const GET_LEARNER_INFO = gql`
  query {
    getLearnerInfo {
      id
      name
      email
      auth_source
      first_name
      last_name
      auth0_id
      is_manager
      role
      has_subscription
      sub_provided_by_chargebee_site
      owned_subscription
      job
      interests {
        id
        title
      }
      company {
        id
        name
        owner_id
        short_name
        logo_url
      }
      teams {
        id
        name
        learner_role
        managers {
          id
          name
        }
      }
    }
  }
`;

export const GET_INVITE_INFO_BY_HASH = gql`
  query($hash: String!) {
    getInviteInfoByHash(hash: $hash) {
      team_name
      company {
        id
        name
      }
      seats_available
    }
  }
`;

export const GET_COMPANY_OWNER_SUBSCRIPTION_INFORMATION = gql`
  query {
    getMySubscriptionCompanyOwnerChargebeeInfo {
      type
      renews_automaticly_on
      pay_frequency
      remaining_trials {
        left
        total
        left_unit
        total_unit
      }
      seats {
        occupied_seats
        bought_seats
        max_count_seats_in_plan
      }
      subscription_id
    }
  }
`;

export const GET_MANAGER_SUBSCRIPTION_INFORMATION = gql`
  query {
    getMySubscriptionTeamManagerChargebeeInfo {
      type
      renews_automaticly_on
      pay_frequency
    }
  }
`;

export const JOIN_TEAM_BY_HASH = gql`
  mutation($hash: String!) {
    joinTeamByInviteHash(hash: $hash) {
      id
    }
  }
`;

export const GET_B2B_LEARNER_SUBSCRIPTION_INFORMATION = gql`
  query {
    getMySubscriptionB2BLearnerChargebeeInfo {
      type
      renews_automaticly_on
      pay_frequency
    }
  }
`;

export const GET_B2C_LEARNER_SUBSCRIPTION_INFORMATION = gql`
  query {
    getMySubscriptionB2CLearnerChargebeeInfo {
      type
      renews_automaticly_on
      pay_frequency
      remaining_trials {
        left
        total
        left_unit
        total_unit
      }
    }
  }
`;

export const UPDATE_COMPANY_INFO = gql`
  mutation($input: CompanyEditInput!) {
    editCompany(input: $input) {
      id
      logo_url
      name
      owner_id
      short_name
    }
  }
`;

export const GET_TEAM_MANAGERS = gql`
  query {
    getTeamManagers {
      id
      name
    }
  }
`;

export const GET_TEAM_INVITE_LINK = gql`
  query($team_id: Int!) {
    getTeamInviteLink(team_id: $team_id) {
      id
      hash
      team_id
    }
  }
`;

export const GET_TEAM_MEMBERS = gql`
  query($team_id: Int!) {
    getTeamMembers(team_id: $team_id) {
      role
      learner {
        id
        name
        email
        role
        last_login
        teams {
          id
        }
      }
    }
  }
`;

export const GET_TEAMS_LIST = gql`
  query {
    getTeamsList {
      all_members_count
      id
      learner_role
      name
    }
  }
`;

export const GET_TEAM = gql`
  query($id: ID!) {
    getTeam(id: $id) {
      all_members_count
      company_id
      name
      id
    }
  }
`;

export const CREATE_TEAM = gql`
  mutation Mytation($input: TeamCreateInput!) {
    createTeam(input: $input) {
      all_members_count
      company_id
      id
      name
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation Mytation($input: TeamUpdateInput!) {
    updateTeam(input: $input)
  }
`;

export const DELETE_TEAM = gql`
  mutation Mytation($input: TeamDeleteInput!) {
    deleteTeam(input: $input)
  }
`;

export const UPDATE_MEMBER_ROLE = gql`
  mutation Mytation($input: TeamMemberRole!) {
    updateMemberRole(input: $input)
  }
`;

export const CHANGE_MEMBER_TEAM = gql`
  mutation Mytation($input: MoveLearnerInOtherTeamInput) {
    moveLearnerToOtherTeam(input: $input)
  }
`;

export const REMOVE_LEARNER_FROM_ORG = gql`
  mutation Mytation($learner_id: Int!) {
    removeLearnerFromCompany(learner_id: $learner_id)
  }
`;

export const REMOVE_LEARNER_FROM_TEAM = gql`
  mutation RemoveLearnerFromTeam($team_id: Int!, $member_id: Int!) {
    removeLearnerFromTeam(team_id: $team_id, member_id: $member_id)
  }
`;

export const INVITE_TO_TEAM = gql`
  mutation Mutation($team_id: Int!, $email: String!) {
    sendTeamInviteEmail(team_id: $team_id, email: $email) {
      hash
      id
      team_id
    }
  }
`;

export const UPDATE_LEARNER_INFO = gql`
  mutation($input: LearnerEditInput!) {
    updateLearnerInfo(input: $input) {
      id
      first_name
      last_name
      name
      job
      interests {
        id
        title
      }
    }
  }
`;

export const GET_COMPANY_LEARNERS = gql`
  query GetCompanyLearners($team_id: Int!, $learner_email: String!) {
    getCompanyLearners(team_id: $team_id, learner_email: $learner_email) {
      id
      name
      email
    }
  }
`;

export const ADD_LEARNER_TO_TEAM = gql`
  mutation AddLearnerToTeam($team_id: Int!, $learner_id: Int!) {
    addLearnerToTeam(team_id: $team_id, learner_id: $learner_id) {
      id
    }
  }
`;
